import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'DX-DAY アイデアソン',
  title1: 'DX-DAY アイデアソン',
  introduction_text:
    'イノベーション案を創出するワークショップを実施しました。このワークショップは参加者の思考の枠を外すことを重視し、スペキュラティブデザイン思考と破壊的イノベーションフレームワークを取り入れました。最終的には3by3ビジネスフレームを用いて、イノベーション案の創出支援を実施しました。',
  company: 'JFE エンジニアリング株式会社',
  tag1text: '組織開発・人材育成',
  tag1src: '/cases/hip/',
  industryTagText: 'メーカー/製造/建設',
  industryTagSrc: '/cases/manufacturing/',
  color: '',
  background: '#F8F8F8',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/jfe.webp',
  alt: 'DX-DAY アイデアソン',
  imgClass: 'fv_img_adjust1',
  noProtrude: true,
}

// プロジェクト概要
export const overviewTitle = 'ワークショップでイノベーション案創出のご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '参加者の思考の枠を外すことを主眼におき、ワークショップを実施いたしました。',
  },
  {
    text: '身近な課題にフォーカスしたアイデアソンでは、既存の延長上にあるスケールの小さなアイデアになってしまいがちです。その為、今回はスペキュラティブデザイン思考を取り入れ、破壊的イノベーションのフレームワークを用いて議論をして頂きました。',
  },
  {
    text: '最終的には3by3ビジネスフレームを用いて、イノベーション案創出のサポートをさせて頂きました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'DX組織が設立されたので、アイデアを多く出したい',
        text: '',
      },
      {
        title: '過去にワークショップを実施したが、想定内のアイデアしか出てこない',
        text: '',
      },
      {
        title: 'イノベーション創造に向けた想定外のアイデアをまずは出したい',
        text: '',
      },
    ],
    solutions: [
      {
        title: '新組織の方向性を踏まえた、事務局との方向性検討',
        text: '',
      },
      {
        title: 'スペキュラティブデザイン思考などを取り入れた、思考の枠を外すアプローチ',
        text: '',
      },
      {
        title: 'ファシリテーターによる、アイデア創出サポート',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
